import { render, staticRenderFns } from "./EnrollmentsList.vue?vue&type=template&id=0082a29b"
import script from "./EnrollmentsList.vue?vue&type=script&lang=js"
export * from "./EnrollmentsList.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentsList.vue?vue&type=style&index=0&id=0082a29b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports